/**
 * PURPOSE: Servicios para campeonatos/eventos.
 * RESPONSIBILITIES:
 *  - Consumir endpoints de campeonatos.
 *  - No maneja UI, loading ni navegación.
 * ROUTE: src/services/championship.js
 */
import httpService from "./httpService.js";

export async function getChampionshipsByCompany({ idcompany, periodo }) {
  return httpService
    .get("/championshipsbycompany", {
      params: {
        idcompany,
        periodo,
      },
    })
    .then((response) => {
      const data = response?.data;
      return Array.isArray(data) ? data : [];
    });
}

export async function getAuthorizedChampionshipsByCompany({
  iduser,
  idcompany,
  periodo,
}) {
  return httpService
    .post("/championshipsbyauthorizedcompany", {
      iduser,
      idcompany,
      periodo,
    })
    .then((response) => {
      const data = response?.data;
      return Array.isArray(data) ? data : [];
    });
}
